import { ValidateIdentityResp } from '@ytl/common-model';
import { axiosInstance } from './axiosInstance';

export const saccResource = {
  async validateIdentity(jwt: string): Promise<ValidateIdentityResp> {
    const res = await axiosInstance.post<ValidateIdentityResp>('/api/sacc/validate-identity', { token: jwt });
    return res.data;
  },
};
